import {
  listQueue,
  listSchedules,
  meetInProgress,
  newMeet,
  reportSchedules,
  searchAllSchedules,
  searchPatient,
  openDoctorQueue,
  closeDoctorQueue,
  pullPatientFromQueue,
  checkDoctorQueue,
  informPatientDelay,
} from '@/services/schedule.service';

export default {
  namespaced: true,
  state: {
    queue: [],
    // queueNext: [],
    queueList: [],
    nextInline: {},
    queueStatus: 'init',
    saveScheduleStatus: 'init',
    searchPatientsStatus: 'init',
    schedulesStatus: 'init',
    pullQueueStatus: 'init',
    DayWeek: 'day',
    searchInput: null,
    userSearch: null,
    searchResult: null,
    meetInProgress: null,
    allSchedules: null,
    // avarageTime: null,
    schedulesReport: null,
    // overbook queue
    openOverbookStatus: 'init',
    closeOverbookStatus: 'init',
    pullOverbookStatus: 'init',
    checkDoctorQueueStatus: 'init',
    isDoctorQueueOpen: false,
    informDelayStatus: 'init',
  },
  getters: {
    // SACHEDULE
    getQueue(state) {
      return state.queue;
    },
    // getQueueNext(state) {
    // 	return state.queueNext;
    // },
    // STATUS
    getQueueResquestStatus(state) {
      return state.queueStatus;
    },
    // STATUS
    getSaveScheduleStatus(state) {
      return state.saveScheduleStatus;
    },
    // LINK FOR MEET IN QUEUE
    getNextInLine(state) {
      return state.nextInline;
    },
    // LIST QUEUE
    getQueueList(state) {
      return state.queueList;
    },
    getSearchInput(state) {
      return state.searchInput;
    },
    getUserSearch(state) {
      return state.userSearch;
    },
    getSearchResult(state) {
      return state.searchResult;
    },
    getMeetInProgress(state) {
      return state.meetInProgress;
    },
    getAllSchedules(state) {
      return state.allSchedules;
    },
    // getAvarageTime(state) {
    // 	return state.avarageTime;
    // },
    getSchedulesReport(state) {
      return state.schedulesReport;
    },
    getSearchPatientsStatus(state) {
      return state.searchPatientsStatus;
    },
    getSchedulesStatus(state) {
      return state.schedulesStatus;
    },
    getOpenOverbookStatus(state) {
      return state.openOverbookStatus;
    },
    getCloseOverbookStatus(state) {
      return state.closeOverbookStatus;
    },
    getPullOverbookStatus(state) {
      return state.pullOverbookStatus;
    },
    getPullQueueStatus(state) {
      return state.pullQueueStatus;
    },
    getCheckDoctorQueueStatus(state) {
      return state.checkDoctorQueueStatus;
    },
    getIsDoctorQueueOpen(state) {
      return state.isDoctorQueueOpen;
    },
    getInformDelayStatus(state) {
      return state.informDelayStatus;
    },
  },
  mutations: {
    // CALENDAR
    SET_QUEUE(state, value) {
      state.queue = value;
    },
    // SET_QUEUE_NEXT(state, value) {
    // 	state.queueNext = value;
    // },
    // STATUS
    SCHEDULES_STATUS(state, value) {
      state.schedulesStatus = value;
    },
    QUEUE_STATUS(state, value) {
      state.queueStatus = value;
    },
    SCHEDULE_STATUS(state, value) {
      state.saveScheduleStatus = value;
    },
    SEARCH_PATIENTS_STATUS(state, value) {
      state.searchPatientsStatus = value;
    },
    // DAYWEEK
    SET_DAYWEEK(state, value) {
      state.DayWeek = value;
    },
    // WAIT LINE
    SET_NEXTINLINE(state, value) {
      state.nextInline = value;
    },
    // QUEUE LIST
    SET_QUEUELIST(state, value) {
      state.queueList = value;
    },
    SET_INPUTSEARCH(state, value) {
      state.searchInput = value;
    },
    SET_USER_SEARCH(state, value) {
      state.userSearch = value;
    },
    SET_SEARCH_RESULT(state, value) {
      state.searchResult = value;
    },
    SET_MEETINPROGRESS(state, value) {
      state.meetInProgress = value;
    },
    SET_ALL_SCHEDULES(state, value) {
      state.allSchedules = value;
    },
    // SET_AVARAGE_TIME(state, value) {
    // 	state.avarageTime = value;
    // },
    SET_SCHEDULES_REPORT(state, value) {
      state.schedulesReport = value;
    },
    OPEN_OVERBOOK_STATUS(state, value) {
      state.openOverbookStatus = value;
    },
    CLOSE_OVERBOOK_STATUS(state, value) {
      state.closeOverbookStatus = value;
    },
    PULL_OVERBOOK_STATUS(state, value) {
      state.pullOverbookStatus = value;
    },
    PULL_QUEUE_STATUS(state, value) {
      state.pullQueueStatus = value;
    },
    CHECK_DOCTOR_QUEUE_STATUS(state, value) {
      state.checkDoctorQueueStatus = value;
    },
    SET_IS_DOCTOR_QUEUE_OPEN(state, value) {
      state.isDoctorQueueOpen = value;
    },
    INFORM_DELAY_STATUS(state, value) {
      state.informDelayStatus = value;
    },
  },
  actions: {
    // async getNext({ commit }) {
    // 	commit("QUEUE_STATUS", "pending");
    // 	try {
    // 		const { data } = await queue();
    // 		commit("SET_QUEUE_NEXT", data);
    // 		commit("QUEUE_STATUS", "init");
    // 	} catch (error) {
    // 		commit("QUEUE_STATUS", "init");
    // 		throw error;
    // 	}
    // },
    async linkNewMeet({ commit }, param) {
      commit('PULL_QUEUE_STATUS', 'pending');
      try {
        const { data } = await newMeet(param);
        commit('PULL_QUEUE_STATUS', 'init');
        commit('SET_NEXTINLINE', data);
        return data;
      } catch (error) {
        commit('PULL_QUEUE_STATUS', 'init');
        throw error;
      }
    },
    async queueList({ commit }) {
      commit('QUEUE_STATUS', 'pending');
      try {
        const { data } = await listQueue();
        commit('QUEUE_STATUS', 'init');
        commit('SET_QUEUELIST', data.items);
      } catch (error) {
        commit('QUEUE_STATUS', 'init');
        throw error;
      }
    },
    async searchPatients({ commit }, param) {
      commit('SEARCH_PATIENTS_STATUS', 'pending');
      try {
        const { data } = await searchPatient(param);
        commit('SEARCH_PATIENTS_STATUS', 'init');
        if (param.type == 'cpf') {
          data.items?.forEach((item) => {
            if (item.users?.length > 0) {
              commit('SET_USER_SEARCH', item);
            }
          });
        }
        commit('SET_SEARCH_RESULT', data);
        return data;
      } catch (error) {
        commit('SEARCH_PATIENTS_STATUS', 'init');
        throw error;
      }
    },
    async meetInProgress({ commit }) {
      commit('SCHEDULES_STATUS', 'pending');
      try {
        const { data } = await meetInProgress();
        commit('SCHEDULES_STATUS', 'init');
        commit('SET_MEETINPROGRESS', data);
        return data;
      } catch (error) {
        commit('SCHEDULES_STATUS', 'init');
        throw error;
      }
    },
    async fetchAllSchedules({ commit }, param) {
      commit('SEARCH_PATIENTS_STATUS', 'pending');
      try {
        const { data } = await searchAllSchedules(param);
        commit('SEARCH_PATIENTS_STATUS', 'init');
        commit('SET_ALL_SCHEDULES', data.items);
        return data;
      } catch (error) {
        commit('SEARCH_PATIENTS_STATUS', 'init');
        throw error;
      }
    },
    async getQueue({ commit }, param) {
      commit('SCHEDULES_STATUS', 'pending');
      try {
        const { data } = await listSchedules(param);
        commit('SET_QUEUE', data.items);
        commit('SCHEDULES_STATUS', 'init');
      } catch (error) {
        commit('SCHEDULES_STATUS', 'init');
        throw error;
      }
    },
    setInputSearch({ commit }, value) {
      commit('SET_INPUTSEARCH', value);
    },
    // async fetchAvarageTime({ commit }) {
    // 	commit("QUEUE_STATUS", "pending");
    // 	try {
    // 		const { data } = await avarageTime();
    // 		commit("SET_AVARAGE_TIME", data);
    // 		commit("QUEUE_STATUS", "init");
    // 		return data;
    // 	} catch (error) {
    // 		commit("QUEUE_STATUS", "init");
    // 		throw error;
    // 	}
    // },
    async fetchReportSchedules({ commit }, param) {
      commit('SCHEDULE_STATUS', 'pending');
      try {
        const { data } = await reportSchedules(param);
        commit('SCHEDULE_STATUS', 'init');
        commit('SET_SCHEDULES_REPORT', data.items);
        return data;
      } catch (error) {
        commit('SCHEDULE_STATUS', 'init');
        throw error;
      }
    },
    async openOverbookQueue({ commit }) {
      commit('OPEN_OVERBOOK_STATUS', 'pending');
      try {
        await openDoctorQueue();
        commit('SET_IS_DOCTOR_QUEUE_OPEN', true);
        commit('OPEN_OVERBOOK_STATUS', 'init');
      } catch (error) {
        commit('OPEN_OVERBOOK_STATUS', 'init');

        throw error;
      }
    },
    async closeOverbookQueue({ commit }) {
      commit('CLOSE_OVERBOOK_STATUS', 'pending');
      try {
        await closeDoctorQueue();
        commit('SET_IS_DOCTOR_QUEUE_OPEN', false);
        commit('CLOSE_OVERBOOK_STATUS', 'init');
      } catch (error) {
        commit('CLOSE_OVERBOOK_STATUS', 'init');

        throw error;
      }
    },
    async pullPatientFromOverbook({ commit }, cpf) {
      commit('PULL_OVERBOOK_STATUS', 'pending');
      try {
        await pullPatientFromQueue(cpf);
        commit('PULL_OVERBOOK_STATUS', 'init');
      } catch (error) {
        commit('PULL_OVERBOOK_STATUS', 'init');

        throw error;
      }
    },
    async checkDoctorQueue({ commit }) {
      commit('CHECK_DOCTOR_QUEUE_STATUS', 'pending');
      try {
        const { data } = await checkDoctorQueue();
        commit('SET_IS_DOCTOR_QUEUE_OPEN', data.queueOpened);
        commit('CHECK_DOCTOR_QUEUE_STATUS', 'init');
      } catch (error) {
        commit('SET_IS_DOCTOR_QUEUE_OPEN', false);
        commit('CHECK_DOCTOR_QUEUE_STATUS', 'init');
        throw error;
      }
    },
    async informPatientDelay({ commit }, { cpf, payload }) {
      commit('INFORM_DELAY_STATUS', 'pending');
      try {
        const { data } = await informPatientDelay(cpf, payload);
        commit('INFORM_DELAY_STATUS', 'init');
        return data;
      } catch (error) {
        commit('INFORM_DELAY_STATUS', 'init');
        throw error;
      }
    },
  },
};
